 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","16":"component---src-pages-404-js","17":"component---src-pages-components-accordion-mdx","18":"component---src-pages-components-anchor-links-mdx","19":"component---src-pages-components-art-direction-index-mdx","20":"component---src-pages-components-article-card-mdx","21":"component---src-pages-components-aside-mdx","22":"component---src-pages-components-caption-mdx","23":"component---src-pages-components-code-blocks-mdx","24":"component---src-pages-components-do-dont-example-mdx","25":"component---src-pages-components-do-dont-row-mdx","26":"component---src-pages-components-feature-card-mdx","27":"component---src-pages-components-feedback-dialog-mdx","28":"component---src-pages-components-gif-player-mdx","29":"component---src-pages-components-grid-mdx","30":"component---src-pages-components-image-card-mdx","31":"component---src-pages-components-image-gallery-mdx","32":"component---src-pages-components-inline-notification-mdx","33":"component---src-pages-components-markdown-mdx","34":"component---src-pages-components-medium-posts-mdx","35":"component---src-pages-components-mini-card-mdx","36":"component---src-pages-components-page-description-mdx","37":"component---src-pages-components-resource-card-mdx","38":"component---src-pages-components-tabs-mdx","39":"component---src-pages-components-title-mdx","40":"component---src-pages-components-video-index-mdx","41":"component---src-pages-contributions-mdx","42":"component---src-pages-demo-index-mdx","43":"component---src-pages-gallery-index-mdx","44":"component---src-pages-getting-started-index-mdx","45":"component---src-pages-guides-configuration-mdx","46":"component---src-pages-guides-hosting-mdx","47":"component---src-pages-guides-mdx-mdx","48":"component---src-pages-guides-navigation-sidebar-mdx","49":"component---src-pages-guides-navigation-tabs-mdx","50":"component---src-pages-guides-npm-scripts-mdx","51":"component---src-pages-guides-shadowing-mdx","52":"component---src-pages-guides-styling-mdx","53":"component---src-pages-index-mdx","54":"component---src-pages-test-spacing-audit-mdx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","16":"9cf8711bc464aaca1763","17":"37438a4cb4a528e679a2","18":"d07beed1cfa6883ee6c0","19":"00487005facb9d93f2ca","20":"768ba4d6c13d4e7f0345","21":"2c7d47f1007527f0d5a3","22":"4306ef82f21858fc8429","23":"65b36d0c81681a829ba3","24":"e2dac4677e23bc8e5940","25":"dae5c9084faae3ade5f1","26":"2c58158a4b478b37d1bf","27":"eac245fd6e6725375c8a","28":"48f5cac923838afc043a","29":"f5adf338cc6221f2793b","30":"ff4bcafafa65a9ae9d63","31":"bc7fd99c7e360d39ee9e","32":"20483dbab1f4715df10d","33":"3709e3e7fbcdf4a88f6a","34":"47cefb31fc3d8956b4d8","35":"0746d7696ea72fb21e24","36":"03617c6c8b8865f1c7aa","37":"4909270338ed5634b5c0","38":"b219cd85440dd025f528","39":"2368a524fddc41d6ab92","40":"01211ef1cb34da043791","41":"bb0734ff9fef3c6fc0c4","42":"d5d90cc7cb2262c7c3c7","43":"da246a13bcf5fb15f407","44":"3c55df89c02f2c24d7cd","45":"552026a612faa9b77c99","46":"5cfa0b39fda722ad75e4","47":"a087afe8bd4696c17c19","48":"3f3d60ada15b9b2fdba6","49":"210fbdb22a45b4c8aea6","50":"e7374e70fd2a48dd329b","51":"2413920922f843a466f4","52":"052889f4889acea9c16a","53":"0cfb6794dcd915df2b7f","54":"724b4d80e8a63eb2b5da"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","16":"component---src-pages-404-js","17":"component---src-pages-components-accordion-mdx","18":"component---src-pages-components-anchor-links-mdx","19":"component---src-pages-components-art-direction-index-mdx","20":"component---src-pages-components-article-card-mdx","21":"component---src-pages-components-aside-mdx","22":"component---src-pages-components-caption-mdx","23":"component---src-pages-components-code-blocks-mdx","24":"component---src-pages-components-do-dont-example-mdx","25":"component---src-pages-components-do-dont-row-mdx","26":"component---src-pages-components-feature-card-mdx","27":"component---src-pages-components-feedback-dialog-mdx","28":"component---src-pages-components-gif-player-mdx","29":"component---src-pages-components-grid-mdx","30":"component---src-pages-components-image-card-mdx","31":"component---src-pages-components-image-gallery-mdx","32":"component---src-pages-components-inline-notification-mdx","33":"component---src-pages-components-markdown-mdx","34":"component---src-pages-components-medium-posts-mdx","35":"component---src-pages-components-mini-card-mdx","36":"component---src-pages-components-page-description-mdx","37":"component---src-pages-components-resource-card-mdx","38":"component---src-pages-components-tabs-mdx","39":"component---src-pages-components-title-mdx","40":"component---src-pages-components-video-index-mdx","41":"component---src-pages-contributions-mdx","42":"component---src-pages-demo-index-mdx","43":"component---src-pages-gallery-index-mdx","44":"component---src-pages-getting-started-index-mdx","45":"component---src-pages-guides-configuration-mdx","46":"component---src-pages-guides-hosting-mdx","47":"component---src-pages-guides-mdx-mdx","48":"component---src-pages-guides-navigation-sidebar-mdx","49":"component---src-pages-guides-navigation-tabs-mdx","50":"component---src-pages-guides-npm-scripts-mdx","51":"component---src-pages-guides-shadowing-mdx","52":"component---src-pages-guides-styling-mdx","53":"component---src-pages-index-mdx","54":"component---src-pages-test-spacing-audit-mdx"}[chunkId]||chunkId) + "." + {"0":"ac1f9c2bf5c1c01a44d4","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
